document.addEventListener('DOMContentLoaded', () => {
  // =========================
  // Tab switching
  // =========================
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');

      const panel = document.getElementById(btn.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });

  // =========================
  // Subscribe pills
  // =========================
  document.querySelectorAll('.pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
    });
  });

  // =========================
  // Sticky bar on scroll
  // =========================
  const stickyBar = document.getElementById('stickyBar');
  if (stickyBar) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 600) stickyBar.classList.add('visible');
      else stickyBar.classList.remove('visible');
    });
  }

  // =========================
  // Add to bag buttons — AJAX cart
  // =========================
  document.querySelectorAll('.product-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      const orig = btn.textContent;

      if (variantId) {
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const cartBtn = document.querySelector('.cart-btn');

          if (cartBtn) {
            cartBtn.textContent = `Bag (${cart.item_count})`;
          }
        } catch (err) {
          console.error('Cart error', err);
        }
      }

      btn.textContent = '✓ Added';
      btn.style.background = 'var(--sage-dark)';
      btn.style.color = '#fff';
      btn.style.borderColor = 'var(--sage-dark)';

      setTimeout(() => {
        btn.textContent = orig;
        btn.style.background = '';
        btn.style.color = '';
        btn.style.borderColor = '';
      }, 1800);
    });
  });

  // =========================
  // Mobile menu toggle
  // =========================
  const menuToggle = document.querySelector('.vw-header__mobile-toggle');
  const mobileMenu = document.querySelector('.vw-header__nav');

  if (menuToggle && mobileMenu) {
    menuToggle.setAttribute('aria-expanded', 'false');

    menuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      mobileMenu.classList.toggle('is-open');

      const isOpen = mobileMenu.classList.contains('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('menu-open', isOpen);
    });

    document.addEventListener('click', (e) => {
      if (!mobileMenu.contains(e.target) && !menuToggle.contains(e.target)) {
        mobileMenu.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        mobileMenu.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
      }
    });
  } else {
    console.warn('vw mobile menu elements not found');
  }
});